module.exports = __webpack_public_path__ + "img/pdu.fd2f8f99.webp";